<template>
     <v-dialog
      v-model="displayDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          TheShopFront
        </v-card-title>
        <v-card-text class="d-flex justify-center">
            {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="displayDialog = false"
          >
            Okay
          </v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ProductExists',
    props:{
        displayDialog:{
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            dialog: false,
            message: 'This product is already in your cart. Increase the counter from your cart to adjust the quantity'
        }
    },
    created (){
        setTimeout(this.display, 2000);  
    },
    methods:{
        display()  {
            this.displayDialog = false
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Product/ProductExists.vue